<template>
  <div class="home-layout-header theme-primary-before-color" :class="{'reverse theme-primary-background-color': reverse}">
    <div class="container">
      <div class="header-cont">
        <div class="header-start" v-if="logoImagLink">
          <router-link :style="{backgroundImage: `url(${logoImagLink})`}" class="school-logo" to="/homeIndex"></router-link>
        </div>
        <div class="header-body">
          <div class="platform-info" :class="{'theme-primary-before-color': !reverse, 'theme-white-before-color': reverse}">
            <span class="title" :class="{'theme-primary-text-color': !reverse, 'theme-white-text-color': reverse}" v-if="title"><span>{{title}}</span><span class="subtitle" v-if="subTitle"><span class="divider">-</span>{{subTitle}}</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      default: '研究生招生系统'
    },
    subTitle: String,
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      logoImagLink: null
    }
  },
  methods: {
    queryStudentLogo () {
      this.$ajax({
        url: '/index/baseSchool/queryStudentLogo',
        method: 'post',
        data: this.$qs.stringify({
          reverse: this.reverse
        })
      }).then(response => {
        this.logoImagLink = response.data['logoImageLink']
      })
    }
  },
  mounted () {
    this.queryStudentLogo()
  }
}
</script>

<style lang="scss">
  @import "../../../styles/theme";

  .home-layout-header {
    position: relative;
    background-color: #fff;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      height: 4px;
      // background-color: $theme-header-primary-color;
    }
    &.reverse {
      // background-color: $theme-header-primary-color;
      &:before {
        display: none;
      }
      &>.container {
        &>.header-cont {
          &>.header-start {
            &>.school-logo {
              background-image: url("../../../assets/common/logo-reverse.png");
            }
          }
          &>.header-body {
            &>.platform-info {
              &:before {
                background-color: #fff;
              }
              &>.title {
                color: #fff;
              }
            }
          }
        }
      }
    }
    &>.container {
      &>.header-cont {
        display: table;
        width: 100%;
        &>.header-start {
          display: table-cell;
          vertical-align: middle;
          &>.school-logo {
            display: block;
            background: url("../../../assets/common/logo.png") center no-repeat;
            background-size: contain;
          }
        }
        &>.header-body {
          display: table-cell;
          vertical-align: middle;
          padding-left: 40px;
          &>.platform-info {
            position: relative;
            &:before {
              content: '';
              position: absolute;
              left: -20px;
              top: 50%;
              width: 1px;
              // background-color: $theme-header-primary-color;
            }
            &>.title {
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              // color: $theme-primary-color;
              line-height: 1;
            }
          }
        }
      }
      @media (max-width: 827px) {
        &>.header-cont {
          height: 76px;
          &>.header-start {
            width: 35%;
            min-width: 140px;
            &>.school-logo {
              height: 40px;
            }
          }
          &>.header-body {
            padding-left: 30px;
            &>.platform-info {
              height: 36px;
              &:before {
                left: -15px;
                height: 36px;
                margin-top: -18px;
              }
              &>.title {
                font-size: 18px;
                &>.subtitle {
                  display: block;
                  font-size: 15px;
                  margin-top: 3px;
                  &>.divider {
                    display: none;
                  }
                }
              }
            }
          }
        }
      }
      @media (min-width: 828px) {
        &>.header-cont {
          height: 112px;
          &>.header-start {
            width: 300px;
            &>.school-logo {
              height: 60px;
            }
          }
          &>.header-body {
            &>.platform-info {
              height: 46px;
              &:before {
                height: 46px;
                margin-top: -23px;
              }
              &>.title {
                font-size: 23px;
              }
            }
          }
        }
      }
      @media (min-width: 1052px) {
        &>.header-cont {
          height: 126px;
          &>.header-start {
            width: 360px;
            &>.school-logo {
              height: 70px;
            }
          }
          &>.header-body {
            &>.platform-info {
              height: 56px;
              &:before {
                height: 56px;
                margin-top: -28px;
              }
              &>.title {
                font-size: 28px;
              }
            }
          }
        }
      }
      @media (min-width: 1260px) {
        &>.header-cont {
          height: 140px;
          &>.header-start {
            width: 390px;
            &>.school-logo {
              height: 76px;
            }
          }
          &>.header-body {
            &>.platform-info {
              height: 60px;
              &:before {
                height: 60px;
                margin-top: -30px;
              }
              &>.title {
                font-size: 32px;
              }
            }
          }
        }
      }
      @media (max-width: 640px) {
        &>.header-cont {
          display: block;
          height: auto;
          padding: 35px 0;
          &>.header-start {
            width:256px;
            height: 52px;
            display: block;
            margin: 0 auto;
            &>.school-logo {
              height: 52px;
              width:256px;
            }
          }
          &>.header-body {
            width: 100%;
            display: block;
            padding: 0;
            &>.platform-info {
              box-sizing: border-box;
              height: 28px;
              line-height: 28px;
              text-align: center;
              width: 256px;
              margin: 20px auto 0;
              padding-left: 60px;
              &:before {
                display: none;
              }
              &>.title {
                position: static;
                font-size: 24px;
                &>span {
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/homeIndex/HomeHeader.vue